



















import config from 'config';
import Vue from 'vue';
import onEscapePress from './mixins/onEscapePress';

export default Vue.extend({
	data () {
		return {
			config
		}
	},
	name: 'Modal' as string,
	mixins: [onEscapePress],
	props: {
		title: {
			type: String,
		},
		categoryProps: {
			type: String,
			default: config.rootcategories.drukowanie
		}
	},
	methods: {
		handleClick(): void {
			this.$emit('closeModal')
		},
		onEscapePress(): void {
			this.$emit('closeModal')
		}
	}
})
